module.exports = Redux;


//////////////////
// WEBPACK FOOTER
// external "Redux"
// module id = 86
// module chunks = 0